function isViewButton(states) {
  var isKey = false;
  //isKey = true;

  let matched = this.$route.matched
  // var array = [];

  if (!matched) {
    return isKey;
  }
  if (!states) {
    return isKey;
  }
  //获取缓存里面的菜单
  var menuList = JSON.parse(window.localStorage.getItem('menuList'))
  // var submenu = matched[1].path
  // var level2Submenu = matched[2].path

  /*var urlArr = [];
  for (var i in matched) {
    if (matched[i].path == '/home') {
      continue;
    }
    urlArr.push(matched[i].path);
  }*/

  //递归查询节点的按钮
  // let node = getLeafNode(menuList, urlArr, 0, states);
  let node = getLeafNode(menuList, matched[matched.length - 1].path, states);
  if (node) {
    isKey = true;
  }

  // for (var i in menuList) {
  //   var path = menuList[i].attributes.path;
  //   //查看是否有一级的权限
  //   var children = menuList[i].children;
  //   if (children && children.length > 0) {
  //     // 查看是否有二级的权限
  //     for (var k in children) {
  //       var level2path = children[k].attributes.path;
  //       if (level2path && level2path.match(level2Submenu)) {
  //         // 如果二级分类存在查看是否有三级的权限
  //         var children1 = children[k].children;
  //         for (var j in children1) {
  //           var submenu1 = children1[j].attributes.extraParams1;
  //           if (submenu1 == states) {
  //             // 如果二级分类存在查看是否有三级的权限
  //             isKey = true;
  //             return isKey;
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  return true;
}

// function getLeafNode(nodes, urlArr, index, states) {
//   var temp = null
//   for (var i in nodes) {
//     if (urlArr.length == index && nodes[i].attributes.extraParams1 == states) {
//       return nodes[i]
//     }
//     if (nodes[i].attributes.path !== null && nodes[i].attributes.path == urlArr[index]) {
//       temp = getLeafNode(nodes[i].children, urlArr, ++index, states);
//       if (temp !== null) {
//         return temp;
//       }
//     }
//   }
//   return temp
// }

function getLeafNode(nodes, path, states) {
  let temp = null
  for (let i in nodes) {
    let children = nodes[i].children;
    if (nodes[i].attributes.path === null) {
      continue
    }
    if (nodes[i].attributes.path === path) {
      for (let j in children) {
        if (children[j].attributes.extraParams1 == states) {
          return children[j]
        }
      }
    }
    temp = getLeafNode(children, path, states);
    if (temp !== null) {
      return temp;
    }
  }
  return temp
}

export default isViewButton
